import React from 'react';
import SlideUpDownNav from './../inc/SlideUpDownNav';
import LogoSVG from './../inc/LogoSVG';

import {
    NavLink,
    Link
} from 'react-router-dom'

// import Player from '@vimeo/player';

// import SwiperCore, { Navigation, Autoplay, A11y, EffectFade } from 'swiper';
// // Import Swiper React components
// import { Swiper, SwiperSlide } from 'swiper/react';

// // Import Swiper styles
// import 'swiper/swiper-bundle.css';

// SwiperCore.use([Navigation, Autoplay, EffectFade, A11y]);       

class Hero extends React.Component {
    constructor(props) {
        super(props);
    }

    componentDidMount() { 
        console.log('hero mount');
    }

    render() {
        let _this = this;
        let page_id = this.props.page_id;
        let hero = this.props.pages.pageData[page_id] ? this.props.pages.pageData[page_id].acf.hero_video : [];    

        return (
            <section className="section">
                <div className="mole__hero mole__home-hero fullW">
                    <figure>
                        {hero.poster &&
                            <img className="poster-img" src={`${hero.poster.url}`}/>
                        }
                        <div className="vimeo-wrapper">
                            {/* <iframe 
                                src={`https://player.vimeo.com/video/${hero.video_id}?autoplay=1&amp;loop=1&amp;muted=1&ammp;title=0&amp;byline=0&amp;portrait=0&amp;background=1`} 
                                frameBorder="0" allow="autoplay">    
                            </iframe>          */}

                            <iframe 
                                src={`https://player.vimeo.com/video/${hero.video_id}?h=8b03630592&autoplay=1&loop=1&autopause=0&muted=1&title=0&byline=0&portrait=0&background=1`} 
                                frameBorder="0" allow="autoplay">  </iframe>                
                        </div>
                        <figcaption className="pos-br font-md">
                            <div className="main-container">
                                <div className="inner-container">
                                    <div className="fig-content fig-hero-content" dangerouslySetInnerHTML={{__html:hero.content}} />
                                    {hero.cta.url &&
                                        <a className="project-link" href={hero.cta.url}>{hero.cta.text}</a>
                                    }
                                </div>
                            </div>
                        </figcaption>
                    </figure>
                </div>
            </section>
        );
    }
}

export default Hero;



// WEBPACK FOOTER //
// ./src/components/Home/Hero.js